import { render, staticRenderFns } from "./CkeBadge.vue?vue&type=template&id=5a01a281&scoped=true"
import script from "./CkeBadge.vue?vue&type=script&lang=js"
export * from "./CkeBadge.vue?vue&type=script&lang=js"
import style0 from "./CkeBadge.vue?vue&type=style&index=0&id=5a01a281&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a01a281",
  null
  
)

export default component.exports